var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi4Bars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 40,
    viewBox: "0 0 57 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5414 36.665C32.3121 34.9531 31.4286 32.9905 29.568 32.2814C27.7074 31.5723 25.5744 32.3853 24.8037 34.0971C24.033 35.809 24.9165 37.7716 26.7771 38.4807C28.6377 39.1898 30.7707 38.3769 31.5414 36.665Z",
    fill: "#6AA442"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9303 28.6124C39.9114 27.4334 39.6698 25.7357 38.3811 24.833C35.7965 23.0141 32.7066 21.9564 29.4409 21.7745C25.099 21.5387 20.9035 22.8726 17.6452 25.5336C16.437 26.5239 16.3272 28.2284 17.4035 29.3399C17.982 29.9395 18.7874 30.2427 19.5928 30.2427C20.2811 30.2427 20.9767 30.0204 21.5405 29.5623C23.6272 27.8578 26.3144 26.9955 29.0968 27.1505C31.1909 27.265 33.1678 27.9387 34.8226 29.1042C36.1113 30.0136 37.9491 29.7913 38.9303 28.6124Z",
    fill: "#6AA442"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0649 21.4968C48.1412 20.3852 48.0387 18.6876 46.8379 17.6905C41.7491 13.5002 35.1813 11.1895 28.3425 11.1895C21.3133 11.1895 14.6137 13.608 9.4663 18.0071C8.28013 19.0177 8.21423 20.7221 9.31254 21.8135C9.89098 22.3861 10.6744 22.6758 11.4579 22.6758C12.1681 22.6758 12.8857 22.44 13.4495 21.9549C17.5059 18.4855 22.7997 16.5789 28.3425 16.5789C33.7388 16.5789 38.9155 18.3979 42.9353 21.7057C44.1361 22.7027 45.9812 22.6017 47.0649 21.4968Z",
    fill: "#6AA442"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61234 13.5885L4.61212 13.5887C4.14779 13.9937 3.5429 14.1998 2.92723 14.1998C2.27042 14.1998 1.62282 13.9603 1.14532 13.4994C0.250308 12.62 0.289654 11.2544 1.24243 10.4214C8.58685 4.02994 18.2071 0.5 28.342 0.5C38.2816 0.5 47.7721 3.91033 55.066 10.1024L55.0666 10.1029C56.0328 10.9206 56.0923 12.2917 55.2055 13.1729C54.2918 14.0809 52.7335 14.1438 51.7453 13.3019L51.7445 13.3013C45.3462 7.87244 37.037 4.88947 28.342 4.88947C19.4838 4.88947 11.0553 7.97494 4.61234 13.5885Z",
    fill: "#6AA442",
    stroke: "#6AA442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi4Bars);
export default __webpack_public_path__ + "static/media/wifi-4-bars.273385af72bae0d5f3f883f052f41d55.svg";
export { ForwardRef as ReactComponent };